module.exports = App.DishGroupsController = Em.Controller.extend

  env:     Em.inject.service('environment')

  # restaurants: Ember.computed ->
  #   @store.find('restaurant')
